import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import { FONT_FAMILY } from '../../../constants/typography';

const FooterToggle = ({ label, value, onChange, tooltip, hideLabel = false, disabled = false }) => {
  const toggle = (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Switch
        checked={!!value}
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
        size="small"
        sx={{
          '& .MuiSwitch-switchBase.Mui-checked': { color: '#FEEC67' },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: 'rgba(254,236,103,0.4)' },
          '& .MuiSwitch-track': { bgcolor: 'rgba(255,255,255,0.2)' },
        }}
      />
      {!hideLabel && (
        <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: 13, fontWeight: 500, color: 'rgba(255,255,255,0.75)', letterSpacing: '0.015em' }}>
          {label}
        </Typography>
      )}
    </Stack>
  );

  // OPUS-1273: `disableInteractive` sets pointer-events:none on the tooltip popper
  // so the tip can never intercept the click/tap on the Switch inside the tight
  // footer popover; a small enter delay keeps the tip non-intrusive for an obvious
  // control. The accessible title is preserved.
  return tooltip ? (
    <Tooltip title={tooltip} disableInteractive enterDelay={400}>
      {toggle}
    </Tooltip>
  ) : toggle;
};

FooterToggle.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  tooltip: PropTypes.string,
  hideLabel: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FooterToggle;
